// import React, { useEffect, useState } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Button,
//   Box,
//   TextField,
//   Typography,
//   Tooltip
// } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
// import SettingsIcon from '@mui/icons-material/Settings';
// import CustomSelect from './CustomSelect'; // Ensure this path is correct
// import InventorySizeRow from './InventorySizeRow'; // Ensure this path is correct
// import { api } from '../helpers/apiRequest';

// const EditInventoryDialog = ({
//   openEditForm,
//   setOpenEditForm,
//   editData,
//   setEditData,
//   parties,
//   partySpecificOptions,
//   sizeOptions,
//   colors,
//   handleOpenAddRecordDialog,
//   handleOpenManagementDialog,
//   handlePartyChange,
//   handleOpenColorDialog,
//   handleEditSizeChange,
//   handleEditRemoveSize,
//   handleEditRecord
// }) => {

//   return (
//     <Dialog
//       open={openEditForm}
//       onClose={() => setOpenEditForm(false)}
//       maxWidth="lg"
//       fullWidth
//       PaperProps={{
//         sx: {
//           minHeight: '70vh',
//           maxHeight: '85vh',
//           width: '80%',
//           padding: '16px'
//         }
//       }}
//     >
//       <DialogTitle
//         sx={{
//           fontSize: '1.4rem',
//           fontWeight: 'bold',
//           pb: 0.5
//         }}
//       >
//         Edit Inventory
//       </DialogTitle>
//       <DialogContent
//         sx={{
//           pt: 1,
//           pb: 1,
//           '&::-webkit-scrollbar': { width: '8px' },
//           '&::-webkit-scrollbar-thumb': {
//             backgroundColor: '#bdbdbd',
//             borderRadius: '4px'
//           }
//         }}
//       >
//         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
//           {/* Row 1 */}
//           <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
//             {/* Party */}
//             <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1 }}>
//               <CustomSelect
//                 label="Party"
//                 value={editData?.party}
//                 onChange={(e) => handlePartyChange(e.target.value)}
//                 options={[
//                   { id: 'all', name: 'all' },
//                   ...parties?.map(p => ({ id: p._id, name: p.name }))
//                 ]}
//                 sx={{ flex: 1 }}
//               />
//               <IconButton onClick={() => handleOpenAddRecordDialog('party')}
//                 sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
//                 <Tooltip title="Add Party"><AddIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
//               </IconButton>
//               <IconButton onClick={() => handleOpenManagementDialog('party')}
//                 sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
//                 <Tooltip title="Management"><SettingsIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
//               </IconButton>
//             </Box>

//             {/* P Style */}
//             <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1 }}>
//               <CustomSelect
//                 label="P Style"
//                 value={editData?.p_style}
//                 onChange={(e) => setEditData({ ...editData, p_style: e.target.value })}
//                 options={partySpecificOptions.pStyles.map(s => ({ id: s._id, name: s.name }))}
//                 disabled={!editData.party}
//                 sx={{ flex: 1 }}
//               />
//               <IconButton onClick={() => handleOpenAddRecordDialog('pStyle')}
//                 sx={{
//                   backgroundColor: colors.primary,
//                   '&:hover': { opacity: 0.9 },
//                   '&.Mui-disabled': { backgroundColor: '#e0e0e0' }
//                 }}
//               >
//                 <Tooltip title="Add pStyle"><AddIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
//               </IconButton>
//               <IconButton onClick={() => handleOpenManagementDialog('pStyle')}
//                 sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
//                 <Tooltip title="Management"><SettingsIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
//               </IconButton>
//             </Box>
//           </Box>

//           {/* Row 2 */}
//           <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
//             {/* Style */}
//             <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1 }}>
//               <CustomSelect
//                 label="Style"
//                 value={editData?.style}
//                 onChange={(e) => setEditData({ ...editData, style: e.target.value })}
//                 options={partySpecificOptions.styles.map(s => ({ id: s._id, name: s.name }))}
//                 disabled={!editData.party}
//                 sx={{ flex: 1 }}
//               />
//               <IconButton onClick={() => handleOpenAddRecordDialog('style')}
//                 sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
//                 <Tooltip title="Add Style"><AddIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
//               </IconButton>
//               <IconButton onClick={() => handleOpenManagementDialog('style')}
//                 sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
//                 <Tooltip title="Management"><SettingsIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
//               </IconButton>
//             </Box>

//             {/* Item */}
//             <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1 }}>
//               <CustomSelect
//                 label="Item"
//                 value={editData?.item}
//                 onChange={(e) => setEditData({ ...editData, item: e.target.value })}
//                 options={partySpecificOptions.items.map(i => ({ id: i._id, name: i.name }))}
//                 disabled={!editData?.party}
//                 sx={{ flex: 1 }}
//               />
//               <IconButton onClick={() => handleOpenAddRecordDialog('item')}
//                 sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
//                 <Tooltip title="Add Item"><AddIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
//               </IconButton>
//               <IconButton onClick={() => handleOpenManagementDialog('item')}
//                 sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
//                 <Tooltip title="Management"><SettingsIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
//               </IconButton>
//             </Box>
//           </Box>

//           {/* Row 3 */}
//           <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
//             <TextField
//               label="Weight"
//               value={editData.weight}
//               onChange={(e) => setEditData({ ...editData, weight: e.target.value })}
//               sx={{ flex: 1 }}
//             />
//             <TextField
//               label="Label"
//               value={editData.label}
//               onChange={(e) => setEditData({ ...editData, label: e.target.value })}
//               sx={{ flex: 1 }}
//             />
//           </Box>
//         </Box>

//         {/* Sizes Section */}
//         <Box sx={{ mt: 2 }}>
//           <Typography variant="subtitle1" gutterBottom>Sizes and Details</Typography>

//           <Box sx={{
//             display: 'flex',
//             gap: 1,
//             mb: 1,
//             backgroundColor: colors.primary,
//             p: 1,
//             textAlign: 'center',
//             borderRadius: '4px',
//             '& > div': {
//               color: 'black',
//               fontWeight: 500,
//               fontSize: '0.9rem',
//               flex: 1,
//               width: '14%'
//             }
//           }}>
//             <Box>Color</Box>
//             {sizeOptions.map((size) => <Box key={size}>{size}</Box>)}
//           </Box>

//           <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
//             {editData.sizes.map((size, index) => (
//               <InventorySizeRow
//                 key={index}
//                 size={size}
//                 index={index}
//                 handleSizeChange={handleEditSizeChange}
//                 handleRemoveSize={handleEditRemoveSize}
//                 sizeOptions={sizeOptions}
//               />
//             ))}
//             <Button
//               variant="contained"
//               startIcon={<AddIcon />}
//               onClick={handleOpenColorDialog}
//               sx={{
//                 mt: 1,
//                 backgroundColor: colors.primary,
//                 color: 'black',
//                 alignSelf: 'flex-start',
//                 '&:hover': { opacity: 0.9 }
//               }}
//             >
//               Add Color
//             </Button>
//           </Box>
//         </Box>
//       </DialogContent>
//       <DialogActions sx={{ p: 1.5, pt: 0 }}>
//         <Button onClick={() => setOpenEditForm(false)} sx={{ color: 'black' }}>Cancel</Button>
//         <Button onClick={handleEditRecord} variant="contained"
//           sx={{ backgroundColor: colors.primary, color: 'black', '&:hover': { opacity: 0.9 } }}>
//           Save
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default EditInventoryDialog;


// import React, { useEffect } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Button,
//   Box,
//   TextField,
//   Typography,
//   Tooltip
// } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
// import SettingsIcon from '@mui/icons-material/Settings';
// import CustomSelect from './CustomSelect';
// import InventorySizeRow from './InventorySizeRow';
// import { api } from '../helpers/apiRequest';

// const EditInventoryDialog = ({
//   openEditForm,
//   setOpenEditForm,
//   editData,
//   setEditData,
//   parties,
//   partySpecificOptions,
//   sizeOptions,
//   colors,
//   handleOpenAddRecordDialog,
//   handleOpenManagementDialog,
//   handlePartyChange,
//   handleOpenColorDialog,
//   handleEditSizeChange,
//   handleEditRemoveSize,
//   handleEditRecord,
//   transformInventoryDataToEditData
// }) => {
//   // Fetch inventory when all filters are selected
//   useEffect(() => {
//     console.log("edit data:",editData);
//     const allSelected =
//       editData?.party && editData?.p_style && editData?.style && editData?.item &&
//       editData?.party !== 'all' &&
//       editData?.p_style !== 'all' &&
//       editData?.style !== 'all' &&
//       editData?.item !== 'all';
//     if (allSelected) {
//       fetchInventory({
//         party: editData?.party,
//         p_style: editData?.p_style,
//         style: editData?.style,
//         item: editData?.item,
//         color: 'all'
//       });
//     }
//   }, [editData?.party, editData?.p_style, editData?.style, editData?.item]);

//   const fetchInventory = async (filtersOverride) => {
//     try {
//       const queryParams = new URLSearchParams();
//       if (filtersOverride.party !== 'all') queryParams.append('party', filtersOverride.party);
//       if (filtersOverride.p_style !== 'all') queryParams.append('p_style', filtersOverride.p_style);
//       if (filtersOverride.style !== 'all') queryParams.append('style', filtersOverride.style);
//       if (filtersOverride.item !== 'all') queryParams.append('item', filtersOverride.item);
//       if (filtersOverride.color !== 'all') queryParams.append('color', filtersOverride.color);

//       const response = await api.get(`inventory/searchstock1?${queryParams.toString()}`);
//       const data = response?.data?.data || [];
//       console.log("data before transformations:",data);
//       const transformed = transformInventoryDataToEditData(data);
//       setEditData(transformed);
//       console.log("data after transformations:",transformed);


//     } catch (error) {
//       console.error('Error fetching inventory:', error);
//     }
//   };

//   return (
//     <Dialog
//       open={openEditForm}
//       onClose={() => setOpenEditForm(false)}
//       maxWidth="lg"
//       fullWidth
//       PaperProps={{
//         sx: {
//           minHeight: '70vh',
//           maxHeight: '85vh',
//           width: '80%',
//           padding: '16px'
//         }
//       }}
//     >
//       <DialogTitle sx={{ fontSize: '1.4rem', fontWeight: 'bold', pb: 0.5 }}>
//         Edit Inventory
//       </DialogTitle>
//       <DialogContent sx={{ pt: 1, pb: 1, '&::-webkit-scrollbar': { width: '8px' }, '&::-webkit-scrollbar-thumb': { backgroundColor: '#bdbdbd', borderRadius: '4px' } }}>
//         <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
//           <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
//             <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1 }}>
//               <CustomSelect
//                 label="Party"
//                 value={editData?.party}
//                 // onChange={(e) => handlePartyChange(e.target.value)}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   handlePartyChange(value);
//                   setEditData(prev => ({ ...prev, party: value }));
//                 }}
//                 options={parties?.map(p => ({ id: p._id, name: p.name }))}
//                 sx={{ flex: 1 }}
//               />
//               <IconButton onClick={() => handleOpenAddRecordDialog('party')} sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
//                 <Tooltip title="Add Party"><AddIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
//               </IconButton>
//               <IconButton onClick={() => handleOpenManagementDialog('party')} sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
//                 <Tooltip title="Management"><SettingsIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
//               </IconButton>
//             </Box>
//             <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1 }}>
//               <CustomSelect
//                 label="P Style"
//                 value={editData?.p_style}
//                 onChange={(e) => setEditData({ ...editData, p_style: e.target.value })}
//                 options={partySpecificOptions.pStyles.map(s => ({ id: s._id, name: s.name }))}
//                 disabled={!editData.party || editData.party === 'all'}
//                 sx={{ flex: 1 }}
//               />
//               <IconButton onClick={() => handleOpenAddRecordDialog('pStyle')} sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
//                 <Tooltip title="Add pStyle"><AddIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
//               </IconButton>
//               <IconButton onClick={() => handleOpenManagementDialog('pStyle')} sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
//                 <Tooltip title="Management"><SettingsIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
//               </IconButton>
//             </Box>
//           </Box>

//           <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
//             <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1 }}>
//               <CustomSelect
//                 label="Style"
//                 value={editData?.style}
//                 onChange={(e) => setEditData({ ...editData, style: e.target.value })}
//                 options={partySpecificOptions.styles.map(s => ({ id: s._id, name: s.name }))}
//                 disabled={!editData.party || editData.party === 'all'}
//                 sx={{ flex: 1 }}
//               />
//               <IconButton onClick={() => handleOpenAddRecordDialog('style')} sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
//                 <Tooltip title="Add Style"><AddIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
//               </IconButton>
//               <IconButton onClick={() => handleOpenManagementDialog('style')} sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
//                 <Tooltip title="Management"><SettingsIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
//               </IconButton>
//             </Box>

//             <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flex: 1 }}>
//               <CustomSelect
//                 label="Item"
//                 value={editData?.item}
//                 onChange={(e) => setEditData({ ...editData, item: e.target.value })}
//                 options={partySpecificOptions.items.map(i => ({ id: i._id, name: i.name }))}
//                 disabled={!editData.party || editData.party === 'all'}
//                 sx={{ flex: 1 }}
//               />
//               <IconButton onClick={() => handleOpenAddRecordDialog('item')} sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
//                 <Tooltip title="Add Item"><AddIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
//               </IconButton>
//               <IconButton onClick={() => handleOpenManagementDialog('item')} sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
//                 <Tooltip title="Management"><SettingsIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
//               </IconButton>
//             </Box>
//           </Box>

//           <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
//             <TextField
//               label="Weight"
//               value={editData.weight}
//               onChange={(e) => setEditData({ ...editData, weight: e.target.value })}
//               sx={{ flex: 1 }}
//             />
//             <TextField
//               label="Label"
//               value={editData.label}
//               onChange={(e) => setEditData({ ...editData, label: e.target.value })}
//               sx={{ flex: 1 }}
//             />
//           </Box>
//         </Box>

//         <Box sx={{ mt: 2 }}>
//           <Typography variant="subtitle1" gutterBottom>Sizes and Details</Typography>
//           <Box sx={{ display: 'flex', gap: 1, mb: 1, backgroundColor: colors.primary, p: 1, textAlign: 'center', borderRadius: '4px', '& > div': { color: 'black', fontWeight: 500, fontSize: '0.9rem', flex: 1, width: '14%' } }}>
//             <Box>Color</Box>
//             {sizeOptions.map((size) => <Box key={size}>{size}</Box>)}
//           </Box>

//           <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
//             {editData.sizes.map((size, index) => (
//               <InventorySizeRow
//                 key={index}
//                 size={size}
//                 index={index}
//                 handleSizeChange={handleEditSizeChange}
//                 handleRemoveSize={handleEditRemoveSize}
//                 sizeOptions={sizeOptions}

//               />
//             ))}
//             <Button
//               variant="contained"
//               startIcon={<AddIcon />}
//               onClick={handleOpenColorDialog}
//               sx={{ mt: 1, backgroundColor: colors.primary, color: 'black', alignSelf: 'flex-start', '&:hover': { opacity: 0.9 } }}
//             >
//               Add Color
//             </Button>
//           </Box>
//         </Box>
//       </DialogContent>
//       <DialogActions sx={{ p: 1.5, pt: 0 }}>
//         <Button onClick={() => setOpenEditForm(false)} sx={{ color: 'black' }}>Cancel</Button>
//         <Button onClick={handleEditRecord} variant="contained" sx={{ backgroundColor: colors.primary, color: 'black', '&:hover': { opacity: 0.9 } }}>
//           Save
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default EditInventoryDialog;

import React, { useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Box,
  TextField,
  Typography,
  Tooltip,
  Grid // Import Grid component
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SettingsIcon from '@mui/icons-material/Settings';
import CustomSelect from './CustomSelect';
import InventorySizeRow from './InventorySizeRow';
import { api } from '../helpers/apiRequest';
import { toast } from 'react-toastify';
import SizeHeader from './SizeHeader';

const EditInventoryDialog = ({
  openEditForm,
  setOpenEditForm,
  editData,
  setEditData,
  parties,
  partySpecificOptions,
  sizeOptions,
  colors,
  handleOpenAddRecordDialog,
  handleOpenManagementDialog,
  handlePartyChange,
  handleOpenColorDialog,
  handleEditSizeChange,
  handleEditRemoveSize,
  handleEditRecord,
  transformInventoryDataToEditData
}) => {
  useEffect(() => {
    console.log("edit data:", editData);
    const allSelected =
      editData?.party && editData?.p_style && editData?.item &&
      editData?.party !== 'all' &&
      editData?.p_style !== 'all' &&
      // editData?.style !== 'all' &&
      editData?.item !== 'all';
    console.log("all selected:", allSelected);
    if (allSelected) {
      fetchInventory({
        party: editData?.party,
        p_style: editData?.p_style,
        // style: editData?.style,
        item: editData?.item,
        color: 'all'
      });
    }
  }, [editData?.party, editData?.style, editData?.item]);

  const fetchInventory = async (filtersOverride) => {
    try {
      const queryParams = new URLSearchParams();
      if (filtersOverride.party !== 'all') queryParams.append('party', filtersOverride.party);
      if (filtersOverride.p_style !== 'all') queryParams.append('p_style', filtersOverride.p_style);
      // if (filtersOverride.style !== 'all') queryParams.append('style', filtersOverride.style);
      if (filtersOverride.item !== 'all') queryParams.append('item', filtersOverride.item);
      if (filtersOverride.color !== 'all') queryParams.append('color', filtersOverride.color);

      const response = await api.get(`inventory/searchstock1?${queryParams.toString()}`);
      const data = response?.data?.data || [];
      console.log("data before transformations:", data);
      if (response.status && data.length > 0) {
        const transformed = transformInventoryDataToEditData(data);
        console.log("here is the transformed data:", transformed);
        setEditData(transformed);
        console.log("data after transformations:", transformed);
      } else {
        setEditData({
          ...editData,
          sizes: []
        });
        toast.error("Stock Not Found");
      }


    } catch (error) {
      console.error('Error fetching inventory:', error);
    }
  };
  const fetchItems = async (party, p_style) => {
    try {
      const queryParams = new URLSearchParams();
      if (party !== 'all') queryParams.append('party', party);
      if (p_style !== 'all') queryParams.append('pstyle', p_style);

      const response = await api.get(`inventory/items_party?${queryParams.toString()}`);
      const data = response?.data?.message || [];

      if (response.status && data.length > 0) {
        // ✅ Update items dynamically
        partySpecificOptions.items = data.map(i => ({ _id: i._id, name: i.name }));
      } else {
        partySpecificOptions.items = [];
        toast.error("No items found for this Party + P Style");
      }
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  };

  return (
    <Dialog
      open={openEditForm}
      onClose={() => setOpenEditForm(false)}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          // Adjust overall dialog width and height for responsiveness
          width: {
            xs: '95%', // 95% width on extra-small screens
            sm: '90%', // 90% width on small screens
            md: '80%', // 80% width on medium screens and up
          },
          minHeight: {
            xs: '80vh', // Slightly more height on mobile for scrollability
            sm: '70vh',
          },
          maxHeight: '85vh',
          padding: {
            xs: '8px', // Smaller padding on extra-small screens
            sm: '16px',
          }
        }
      }}
    >
      <DialogTitle sx={{ fontSize: { xs: '1.2rem', sm: '1.4rem' }, fontWeight: 'bold', pb: 0.5 }}>
        Edit Inventory
      </DialogTitle>
      <DialogContent sx={{
        pt: 1, pb: 1,
        '&::-webkit-scrollbar': { width: '8px' },
        '&::-webkit-scrollbar-thumb': { backgroundColor: '#bdbdbd', borderRadius: '4px' }
      }}>
        <Box sx={{ mt: 2 }}>
          {/* Main Grid container for all input fields */}
          <Grid container spacing={2}>
            {/* Party Select and Buttons */}
            <Grid item xs={12} sm={6}> {/* Takes full width on xs, half on sm */}
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <CustomSelect
                  label="Party"
                  value={editData?.party}
                  onChange={(e) => {
                    const value = e.target.value;
                    // // setEditData({ ...editData, party: e.target.value })
                    setEditData(prev => ({ ...prev, party: value.toString().trim() }));
                    handlePartyChange(value);

                  }}
                  options={parties?.map(p => ({ id: p._id, name: p.name }))}
                  sx={{ flex: 1 }}
                />
                <IconButton onClick={() => handleOpenAddRecordDialog('party')} sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
                  <Tooltip title="Add Party"><AddIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
                </IconButton>
                <IconButton onClick={() => handleOpenManagementDialog('party')} sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
                  <Tooltip title="Management"><SettingsIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
                </IconButton>
              </Box>
            </Grid>

            {/* P Style Select and Buttons */}
            {/* <Grid item xs={12} sm={6}>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <CustomSelect
                  label="P Style/Style"
                  value={editData?.p_style}
                  onChange={(e) => setEditData({ ...editData, p_style: e.target.value })}
                  options={partySpecificOptions.pStyles.map(s => ({ id: s._id, name: s.name }))}
                  disabled={!editData?.party || editData?.party === 'all'}
                  sx={{ flex: 1 }}
                />
                <IconButton onClick={() => handleOpenAddRecordDialog('pStyle')} sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
                  <Tooltip title="Add pStyle"><AddIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
                </IconButton>
                <IconButton onClick={() => handleOpenManagementDialog('pStyle')} sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
                  <Tooltip title="Management"><SettingsIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
                </IconButton>
              </Box>
            </Grid> */}
            {/* P Style Select and Buttons */}
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <CustomSelect
                  label="P Style/Style"
                  value={editData?.p_style}
                  onChange={async (e) => {
                    const value = e.target.value;
                    setEditData({ ...editData, p_style: value.toString().trim() });

                    // ✅ Fetch items whenever p_style changes
                    if (editData?.party && value) {
                      await fetchItems(editData?.party, value);
                    }
                  }}
                  options={partySpecificOptions.pStyles.map(s => ({ id: s._id, name: s.name }))}
                  disabled={!editData?.party || editData?.party === 'all'}
                  sx={{ flex: 1 }}
                />
                <IconButton onClick={() => handleOpenAddRecordDialog('pStyle')} sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
                  <Tooltip title="Add pStyle"><AddIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
                </IconButton>
                <IconButton onClick={() => handleOpenManagementDialog('pStyle')} sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
                  <Tooltip title="Management"><SettingsIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
                </IconButton>
              </Box>
            </Grid>

            {/* Style Select and Buttons */}


            {/* Item Select and Buttons */}
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <CustomSelect
                  label="Item"
                  value={editData?.item}
                  onChange={(e) => setEditData({ ...editData, item: e.target?.value?.toString()?.trim() })}
                  options={partySpecificOptions.items.map(i => ({ id: i._id, name: i.name }))}
                  disabled={!editData?.party || editData?.party === 'all'}
                  sx={{ flex: 1 }}
                />
                <IconButton onClick={() => handleOpenAddRecordDialog('item')} sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
                  <Tooltip title="Add Item"><AddIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
                </IconButton>
                <IconButton onClick={() => handleOpenManagementDialog('item')} sx={{ backgroundColor: colors.primary, '&:hover': { opacity: 0.9 } }}>
                  <Tooltip title="Management"><SettingsIcon sx={{ color: 'black', fontSize: 22 }} /></Tooltip>
                </IconButton>
              </Box>
            </Grid>

            {/* Weight and Label TextFields */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Weight"
                value={editData?.weight}
                onChange={(e) => setEditData({ ...editData, weight: e.target.value })}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Label"
                value={editData?.label}
                onChange={(e) => setEditData({ ...editData, label: e.target.value })}
                fullWidth
              />
            </Grid>
          </Grid>
        </Box>

        {/* Sizes and Details Section */}
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" gutterBottom sx={{ fontSize: { xs: '0.95rem', sm: '1rem' } }}>
            Sizes and Details
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              mb: 1,
              backgroundColor: colors.primary,
              p: 1,
              textAlign: 'center',
              borderRadius: '4px',
              overflowX: 'auto', // Allow horizontal scroll for sizes header
              '& > div': {
                color: 'black',
                fontWeight: 500,
                fontSize: { xs: '0.7rem', sm: '0.9rem' },
                flex: 1,
                minWidth: '70px', // Ensure min width for each size column
              }
            }}
          >
            <SizeHeader />
            {/* <Box>Color</Box>
            {sizeOptions.map((size) => <Box key={size}>{size}</Box>)} */}
          </Box>

          <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
            {editData?.sizes?.map((size, index) => (
              <InventorySizeRow
                key={index}
                size={size}
                index={index}
                handleSizeChange={handleEditSizeChange}
                handleRemoveSize={() => handleEditRemoveSize(editData?.party, editData?.p_style, editData?.item, size?.color, index)}
                sizeOptions={sizeOptions}
              />
            ))}
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleOpenColorDialog}
              sx={{
                mt: 1,
                backgroundColor: colors.primary,
                color: 'black',
                // Align button left on larger screens, full width on small
                alignSelf: {
                  xs: 'stretch', // Stretches to full width on xs
                  sm: 'flex-start' // Aligns to start on sm and up
                },
                '&:hover': { opacity: 0.9 }
              }}
            >
              Add Color
            </Button>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 1.5, pt: 0, justifyContent: { xs: 'space-between', sm: 'flex-end' } }}>
        <Button onClick={() => setOpenEditForm(false)} sx={{ color: 'black' }}>Cancel</Button>
        <Button onClick={handleEditRecord} variant="contained" sx={{ backgroundColor: colors.primary, color: 'black', '&:hover': { opacity: 0.9 } }}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditInventoryDialog;
